export default __webpack_public_path__ + "0e5a67e6477b29955a665824dddc9d88.svg";